export type InputTypeEnum = 'homeInput' | 'normal';
export const DISABLE_EDIT_MSG_ID = 'disable-edit';
